// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"ccb2fcb9","336":"ab2a6ca8","338":"50e068cc","375":"564f4f62","551":"a09386f4","629":"8226f8b8","645":"ebbbae5a","745":"ee3868b5","800":"7903e846","941":"6a2d6cd8"}[chunkId] + ".chunk.js";
};